import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getCookie } from "utils/setCookie";

export const getListPost = async (params): Promise<any> => {
  const url = `${process.env.REACT_APP_AJAX_URL}community/list`;
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    params: params,
  };
  // Deliberately not wrapped in a generic try/catch: the caller needs the
  // real error.response.data.message (e.g. a backend 500) to distinguish a
  // failed fetch from a genuinely empty result list.
  return await axios.get(url, axiosConfig);
};

export const updateStatusPost = async (data: any): Promise<any> => {
  const url = process.env.REACT_APP_AJAX_URL + `community/update`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    return await axios.patch(url, data, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const deletePost = async (_id: string): Promise<any> => {
  const url = process.env.REACT_APP_AJAX_URL + `community/delete/${_id}`;
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  // Deliberately not wrapped in a generic try/catch: the backend returns a
  // 404 for both "not found" and "not allowed" (see community.helper.ts),
  // and the caller needs the real error.response.data.message to tell them
  // apart rather than a swallowed "Failed to fetch user data".
  return await axios.delete(url, axiosConfig);
};
